import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              期待与你的合作
            </p>
          </div>
          <div className="rounded-2xl bg-background-100 border border-background-200/60 p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {contactInfo.desc}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">官方微信</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">客服热线</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.qq}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">公司地址</div>
                  <div className="text-sm font-medium text-foreground-800">{contactInfo.address}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}